import { useState, useEffect } from 'react';

const DISMISSED_COMPONENTS_KEY = 'STORM_UI_DISMISSED_COMPONENTS';

// Utility function to get the list of dismissed components from localStorage
const getDismissedComponents = () => {
  try {
    return JSON.parse(localStorage.getItem(DISMISSED_COMPONENTS_KEY) || '[]');
  } catch (_unused) {
    return [];
  }
};

/**
 * Manages the dismissal state of a component by checking and updating its status in localStorage.
 * @param id - Component's unique identifier. If provided, the dismissal state will be persisted in localStorage
 * @returns [boolean, () => void] - A tuple containing:
 *   - isDismissed: boolean - Current dismissal state of the component
 *   - dismiss: () => void - Function to dismiss the component and update localStorage if an ID was provided
 *  */
const useDismissibleComponent = id => {
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (id) {
      const dismissedComponents = getDismissedComponents();
      setIsDismissed(dismissedComponents.includes(id));
    } else {
      setIsDismissed(false);
    }
  }, [id]);
  const dismiss = () => {
    if (id) {
      const dismissedComponents = getDismissedComponents();
      const updatedDismissedComponents = [...dismissedComponents, id];
      localStorage.setItem(DISMISSED_COMPONENTS_KEY, JSON.stringify(updatedDismissedComponents));
    }
    setIsDismissed(true);
  };
  return [isDismissed, dismiss];
};

export { useDismissibleComponent as u };
//# sourceMappingURL=useDismissibleComponent-CVK8tCpX.js.map
